import { getCurrentInstance } from '@vue/composition-api';

function resolveRootStore() {
  const instance = getCurrentInstance();
  return instance && instance.proxy ? instance.proxy.$store : null;
}

function normalizeFeatures(store) {
  const state = store ? store.state : {};
  const user = state.user || {};
  const rawFeatures = state.user_features || {};
  const roles = user.roles || {};

  return {
    ...rawFeatures,
    permissions: rawFeatures.permissions && typeof rawFeatures.permissions === 'object'
      ? rawFeatures.permissions
      : rawFeatures,
    is_admin_user: Boolean(user.is_admin_user || rawFeatures.is_admin_user),
    is_forum_writer_user: Boolean(user.is_forum_writer_user || rawFeatures.is_forum_writer_user),
    is_forum_moderator_user: Boolean(rawFeatures.is_forum_moderator_user),
    is_bronze_user: Boolean(user.is_bronze_user || rawFeatures.is_bronze_user),
    is_silver_user: Boolean(user.is_silver_user || rawFeatures.is_silver_user),
    is_gold_user: Boolean(user.is_gold_user || rawFeatures.is_gold_user),
    is_platinum_user: Boolean(user.is_platinum_user || rawFeatures.is_platinum_user),
    is_pre_eureker_user: Boolean(user.is_pre_eureker_user || rawFeatures.is_pre_eureker_user),
    is_basic_user: Boolean(user.is_basic_user || rawFeatures.is_basic_user),
    is_restricted_charting_user: Boolean(roles[20] || roles[21] || rawFeatures.is_restricted_charting_user)
  };
}

export function useChartingSession() {
  const store = resolveRootStore();

  return {
    get uid() {
      return Number((store && store.state.user_id) || 0);
    },
    get user() {
      return store && store.state.user ? store.state.user : null;
    },
    get features() {
      return normalizeFeatures(store);
    },
    get isAuthenticated() {
      const uid = Number((store && store.state.user_id) || 0);
      return Number.isFinite(uid) && uid > 0;
    }
  };
}
